import { gql } from 'graphql-request';
import { UpdateQuantityResponseResult } from '@types';

export interface UpdateProductQuantityResponse {
  wChangeQty: { result: UpdateQuantityResponseResult; };
}

export const UPDATE_PRODUCT_QUANTITY_MUTATION = gql`
  mutation wChangeQty($orderUid: UUID!, $orderItemUid: UUID!, $qty: BigDecimal!) {
    wChangeQty(orderUid: $orderUid, orderItemUid: $orderItemUid, qty: $qty)
  }`;
